var _defs, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketingImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1941.89 2249.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 882.96,
    y1: 4888.74,
    x2: 928.44,
    y2: 4888.74,
    gradientTransform: "matrix(-1 .6 0 1 2089.44 -4292.47)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 1841.22,
    y1: 3502.52,
    x2: 1841.22,
    y2: 3494.18,
    gradientTransform: "matrix(-1 .6 0 1 3280.4 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1302.43,
    y1: 830.65,
    x2: 1270.19,
    y2: 948.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d33f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff800a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1346.82,
    y1: 818.5,
    x2: 1645.88,
    y2: 818.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7c0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 983.11,
    y1: 364.89,
    x2: 748.41,
    y2: 835,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1232.75,
    y1: 1140.06,
    x2: 1496.35,
    y2: 1140.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c6fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ca3d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1142.31,
    y1: 995.03,
    x2: 1329.22,
    y2: 995.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1861.38,
    y1: 3484.98,
    x2: 1861.38,
    y2: 3476.7,
    gradientTransform: "matrix(-1 .6 0 1 3280.4 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1392.83,
    y1: 434.54,
    x2: 1162.05,
    y2: 896.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1113.33,
    y1: 483.35,
    x2: 1419.81,
    y2: 483.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ca8c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3c9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1334.61,
    y1: 789.87,
    x2: 1330.7,
    y2: 486.45,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1306.93,
    y1: 1052.39,
    x2: 727.56,
    y2: 836.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1755.53,
    y1: 763.95,
    x2: 2089.44,
    y2: 763.95,
    gradientTransform: "matrix(-1 0 0 1 2089.44 -125.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc5d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebedf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2080.19,
    y1: 668.02,
    x2: 1750.88,
    y2: 547.14,
    gradientTransform: "matrix(-1 0 0 1 2089.44 -125.09)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2117.33,
    y1: 998.41,
    x2: 2034.87,
    y2: 720.63,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1900.72,
    y1: 501.56,
    x2: 1900.72,
    y2: 728.2,
    gradientTransform: "matrix(-1 0 0 1 2089.44 -125.09)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1764.49,
    y1: 552.37,
    x2: 1770.81,
    y2: 563.31,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1791.41,
    y1: 568.92,
    x2: 1797.73,
    y2: 579.85,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd38d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1793,
    y1: 586.81,
    x2: 1787.46,
    y2: 567.41,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1818.33,
    y1: 585.46,
    x2: 1824.65,
    y2: 596.4,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1819.92,
    y1: 603.35,
    x2: 1814.37,
    y2: 583.95,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 11467.98,
    y1: 818.02,
    x2: 11680.02,
    y2: 818.02,
    gradientTransform: "translate(-10867.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d33f11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7c0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 11602.01,
    y1: 743.17,
    x2: 11536.22,
    y2: 899.19,
    gradientTransform: "translate(-10867.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 11467.98,
    y1: 888.73,
    x2: 11473.93,
    y2: 888.73,
    gradientTransform: "translate(-11396.45 -125.09)",
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 11466.61,
    y1: 771.17,
    x2: 11701.45,
    y2: 771.17,
    gradientTransform: "translate(-10867.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#879cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f5baa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 11680.13,
    y1: 687.14,
    x2: 11564.83,
    y2: 814.73,
    gradientTransform: "translate(-10867.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#879cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c75bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 851.69,
    y1: 1273.56,
    x2: 1324.79,
    y2: 1273.56,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1311.68,
    y1: 1126.43,
    x2: 845.09,
    y2: 955.17,
    gradientTransform: "matrix(-1 0 0 1 2089.44 -125.09)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1366.95,
    y1: 1614.66,
    x2: 1244.48,
    y2: 1202.14,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1057.4,
    y1: 890.59,
    x2: 1057.4,
    y2: 1211.69,
    gradientTransform: "matrix(-1 0 0 1 2089.44 -125.09)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 864.39,
    y1: 962.58,
    x2: 873.34,
    y2: 978.07,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 902.52,
    y1: 986.02,
    x2: 911.48,
    y2: 1001.51,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 904.78,
    y1: 1011.37,
    x2: 896.92,
    y2: 983.88,
    gradientTransform: "matrix(-.5 -.86 -.86 .5 3034.21 1276.66)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 940.66,
    y1: 1009.46,
    x2: 949.62,
    y2: 1024.95,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 942.91,
    y1: 1034.81,
    x2: 935.06,
    y2: 1007.32,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1110.75,
    y1: 1442.46,
    x2: 963.61,
    y2: 1152.32,
    gradientTransform: "matrix(-1 0 0 1 2618.5 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc5d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4dae2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 882.96,
    y1: 4783.46,
    x2: 928.44,
    y2: 4783.46,
    gradientTransform: "matrix(-1 .6 0 1 2089.44 -4292.47)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1074.02,
    y1: 4772.84,
    x2: 1074.02,
    y2: 4766.61,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1074.02,
    y1: 4786.57,
    x2: 1074.02,
    y2: 4780.35,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1040.57,
    y1: 4800.3,
    x2: 1040.57,
    y2: 4794.08,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 882.96,
    y1: 4836.1,
    x2: 928.44,
    y2: 4836.1,
    gradientTransform: "matrix(-1 .6 0 1 2089.44 -4292.47)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1074.02,
    y1: 4825.48,
    x2: 1074.02,
    y2: 4819.25,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1074.02,
    y1: 4839.21,
    x2: 1074.02,
    y2: 4832.98,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1040.57,
    y1: 4852.94,
    x2: 1040.57,
    y2: 4846.72,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1162.84,
    y1: 785.1,
    x2: 1272.8,
    y2: 785.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c6fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c519b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1074.02,
    y1: 4878.11,
    x2: 1074.02,
    y2: 4871.89,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1074.02,
    y1: 4891.85,
    x2: 1074.02,
    y2: 4885.62,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1040.57,
    y1: 4905.58,
    x2: 1040.57,
    y2: 4899.35,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 882.96,
    y1: 4941.38,
    x2: 928.44,
    y2: 4941.38,
    gradientTransform: "matrix(-1 .6 0 1 2089.44 -4292.47)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1074.02,
    y1: 4930.75,
    x2: 1074.02,
    y2: 4924.52,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1074.02,
    y1: 4944.48,
    x2: 1074.02,
    y2: 4938.26,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1040.57,
    y1: 4958.22,
    x2: 1040.57,
    y2: 4951.99,
    gradientTransform: "matrix(-1 .6 0 1 2618.5 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1899.78,
    y1: 1622.04,
    x2: 1847.12,
    y2: 1470,
    gradientTransform: "matrix(-1 0 0 1 2089.44 -125.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc5d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee2e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1761.43,
    y1: 1380.74,
    x2: 1719.01,
    y2: 1258.24,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1782.95,
    y1: 4443.33,
    x2: 1782.95,
    y2: 4454.68,
    gradientTransform: "matrix(-1 .57 0 1 2618.39 -3992.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bcc5d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1782.95,
    y1: 4406.62,
    x2: 1782.95,
    y2: 4417.97,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1782.95,
    y1: 4478.84,
    x2: 1782.95,
    y2: 4490.19,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1741.8,
    y1: 4515.47,
    x2: 1741.8,
    y2: 4525.8,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1741.8,
    y1: 4550.99,
    x2: 1741.8,
    y2: 4561.32,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1741.8,
    y1: 4586.5,
    x2: 1741.8,
    y2: 4596.84,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1721.29,
    y1: 4621.79,
    x2: 1721.29,
    y2: 4632.33,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 9099.71,
    y1: 2131.92,
    x2: 9439.6,
    y2: 2131.92,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e5883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262847"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 9099.94,
    y1: 2115.59,
    x2: 9440.1,
    y2: 2115.59,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 9224.81,
    y1: 2081.38,
    x2: 9302.71,
    y2: 2081.38,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 9243.28,
    y1: 2024.64,
    x2: 9284.24,
    y2: 2024.64,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 9218.04,
    y1: 1953.55,
    x2: 9309.48,
    y2: 1953.55,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 9541.74,
    y1: 1779.23,
    x2: 9296.19,
    y2: 1796.56,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 9815.86,
    y1: 1972.17,
    x2: 9723.65,
    y2: 2014.59,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 9728.61,
    y1: 1772.1,
    x2: 9640.48,
    y2: 1778.32,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 9430.2,
    y1: 1629.9,
    x2: 9478.59,
    y2: 1819.91,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 9660.13,
    y1: 1466.06,
    x2: 9454.87,
    y2: 1502.55,
    gradientTransform: "matrix(-.96 -.07 -.07 1 11369.11 374.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de8b8b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 9668.77,
    y1: 1366.03,
    x2: 9457.73,
    y2: 1403.55,
    gradientTransform: "matrix(-.96 -.07 -.07 1 11369.11 374.53)",
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 9729.88,
    y1: 1498.79,
    x2: 9540.92,
    y2: 1585.7,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 9467.64,
    y1: 1423.27,
    x2: 9135.01,
    y2: 1482.4,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 9517.8,
    y1: 1415.3,
    x2: 9436.65,
    y2: 1459.38,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 9596.68,
    y1: 1457.46,
    x2: 9635.86,
    y2: 1533.71,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 9770.56,
    y1: 1344.78,
    x2: 9810.15,
    y2: 1421.84,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-70"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 9715.59,
    y1: 1647.84,
    x2: 9896.76,
    y2: 1647.84,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 9111.65,
    y1: 1420.24,
    x2: 9111.65,
    y2: 1919.21,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc5d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48517a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 9466.46,
    y1: 1612.87,
    x2: 9031.5,
    y2: 1643.57,
    gradientTransform: "matrix(-1 0 0 1 11384.77 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1962.43,
    y1: 290.37,
    x2: 1634,
    y2: 169.82,
    gradientTransform: "matrix(-1 0 0 1 2751.34 -125.09)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1988.07,
    y1: 533.2,
    x2: 1930.07,
    y2: 337.82,
    gradientTransform: "matrix(-1 0 0 1 2751.34 -125.09)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1722.15,
    y1: 363.87,
    x2: 1679.7,
    y2: 215.31,
    gradientTransform: "matrix(-1 0 0 1 3280.4 0)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1861.38,
    y1: 3390.01,
    x2: 1861.38,
    y2: 3381.72,
    gradientTransform: "matrix(-1 .6 0 1 3280.4 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1861.38,
    y1: 3407.55,
    x2: 1861.38,
    y2: 3399.26,
    gradientTransform: "matrix(-1 .6 0 1 3280.4 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 1841.22,
    y1: 3425.08,
    x2: 1841.22,
    y2: 3416.74,
    gradientTransform: "matrix(-1 .6 0 1 3280.4 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 1861.38,
    y1: 3467.44,
    x2: 1861.38,
    y2: 3459.16,
    gradientTransform: "matrix(-1 .6 0 1 3280.4 -4167.38)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-529.06 -125.09)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1162.84 747.84 90.45 52.56c8.19 4.76 14.85 12.17 19.51 22l-90.45-52.56c-4.65-9.84-11.35-17.24-19.51-22Z"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient)}.cls-2{opacity:.1}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#190c00}.cls-3{opacity:0}.cls-4{opacity:.04}.cls-5{opacity:.08}.cls-6{opacity:.13}.cls-7{opacity:.17}.cls-8{opacity:.21}.cls-9{opacity:.25}.cls-10{opacity:.29}.cls-11{opacity:.33}.cls-12{opacity:.38}.cls-13{opacity:.42}.cls-14{opacity:.46}.cls-15{opacity:.5}.cls-16{opacity:.54}.cls-17{opacity:.58}.cls-18{opacity:.63}.cls-19{opacity:.67}.cls-20{opacity:.71}.cls-21{opacity:.75}.cls-22{opacity:.79}.cls-23{opacity:.83}.cls-24{opacity:.88}.cls-25{opacity:.92}.cls-26{opacity:.96}.cls-35{fill:#dcdcdc}.cls-44{fill:#eef0f2}.cls-48{fill:#385da5}.cls-50{fill:#7f98d3}.cls-56{fill:none;stroke:#989b9b;stroke-miterlimit:10;stroke-width:.5px}.cls-104{fill:#dcdbdc}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1410.14,
    cy: 2020.24,
    rx: 401.9,
    ry: 225.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1410.14,
    cy: 2020.24,
    rx: 394.02,
    ry: 220.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1410.14,
    cy: 2020.24,
    rx: 386.14,
    ry: 216.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1410.14,
    cy: 2020.24,
    rx: 378.26,
    ry: 211.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1410.14,
    cy: 2020.24,
    rx: 370.37,
    ry: 207.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1410.14,
    cy: 2020.24,
    rx: 362.49,
    ry: 203.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1410.14,
    cy: 2020.24,
    rx: 354.61,
    ry: 198.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1410.14,
    cy: 2020.24,
    rx: 346.73,
    ry: 194.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1410.14,
    cy: 2020.24,
    rx: 338.84,
    ry: 189.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1410.14,
    cy: 2020.24,
    rx: 330.96,
    ry: 185.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1410.14,
    cy: 2020.24,
    rx: 323.08,
    ry: 181
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1410.14,
    cy: 2020.24,
    rx: 315.2,
    ry: 176.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1410.14,
    cy: 2020.24,
    rx: 307.32,
    ry: 172.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1410.14,
    cy: 2020.24,
    rx: 299.43,
    ry: 167.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1410.14,
    cy: 2020.24,
    rx: 291.55,
    ry: 163.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1410.14,
    cy: 2020.24,
    rx: 283.67,
    ry: 158.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1410.14,
    cy: 2020.24,
    rx: 275.79,
    ry: 154.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 1410.14,
    cy: 2020.24,
    rx: 267.9,
    ry: 150.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 1410.14,
    cy: 2020.24,
    rx: 260.02,
    ry: 145.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 1410.14,
    cy: 2020.24,
    rx: 252.14,
    ry: 141.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1410.14,
    cy: 2020.24,
    rx: 244.26,
    ry: 136.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1410.14,
    cy: 2020.24,
    rx: 236.38,
    ry: 132.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 1410.14,
    cy: 2020.24,
    rx: 228.49,
    ry: 128.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 1410.14,
    cy: 2020.24,
    rx: 220.61,
    ry: 123.59
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 658.17,
    cy: 1146.34,
    rx: 401.9,
    ry: 225.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 658.17,
    cy: 1146.34,
    rx: 394.02,
    ry: 220.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 658.17,
    cy: 1146.34,
    rx: 386.14,
    ry: 216.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 658.17,
    cy: 1146.34,
    rx: 378.26,
    ry: 211.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 658.17,
    cy: 1146.34,
    rx: 370.37,
    ry: 207.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 658.17,
    cy: 1146.34,
    rx: 362.49,
    ry: 203.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 658.17,
    cy: 1146.34,
    rx: 354.61,
    ry: 198.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 658.17,
    cy: 1146.34,
    rx: 346.73,
    ry: 194.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 658.17,
    cy: 1146.34,
    rx: 338.84,
    ry: 189.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 658.17,
    cy: 1146.34,
    rx: 330.96,
    ry: 185.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 658.17,
    cy: 1146.34,
    rx: 323.08,
    ry: 181
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 658.17,
    cy: 1146.34,
    rx: 315.2,
    ry: 176.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 658.17,
    cy: 1146.34,
    rx: 307.32,
    ry: 172.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 658.17,
    cy: 1146.34,
    rx: 299.43,
    ry: 167.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 658.17,
    cy: 1146.34,
    rx: 291.55,
    ry: 163.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 658.17,
    cy: 1146.34,
    rx: 283.67,
    ry: 158.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 658.17,
    cy: 1146.34,
    rx: 275.79,
    ry: 154.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 658.17,
    cy: 1146.34,
    rx: 267.9,
    ry: 150.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 658.17,
    cy: 1146.34,
    rx: 260.02,
    ry: 145.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 658.17,
    cy: 1146.34,
    rx: 252.14,
    ry: 141.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 658.17,
    cy: 1146.34,
    rx: 244.26,
    ry: 136.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 658.17,
    cy: 1146.34,
    rx: 236.38,
    ry: 132.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 658.17,
    cy: 1146.34,
    rx: 228.49,
    ry: 128.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 658.17,
    cy: 1146.34,
    rx: 220.61,
    ry: 123.59
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 711.77,
    cy: 1449.25,
    rx: 401.9,
    ry: 225.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 711.77,
    cy: 1449.25,
    rx: 394.02,
    ry: 220.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 711.77,
    cy: 1449.25,
    rx: 386.14,
    ry: 216.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 711.77,
    cy: 1449.25,
    rx: 378.26,
    ry: 211.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 711.77,
    cy: 1449.25,
    rx: 370.37,
    ry: 207.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 711.77,
    cy: 1449.25,
    rx: 362.49,
    ry: 203.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 711.77,
    cy: 1449.25,
    rx: 354.61,
    ry: 198.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 711.77,
    cy: 1449.25,
    rx: 346.73,
    ry: 194.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 711.77,
    cy: 1449.25,
    rx: 338.84,
    ry: 189.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 711.77,
    cy: 1449.25,
    rx: 330.96,
    ry: 185.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 711.77,
    cy: 1449.25,
    rx: 323.08,
    ry: 181
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 711.77,
    cy: 1449.25,
    rx: 315.2,
    ry: 176.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 711.77,
    cy: 1449.25,
    rx: 307.32,
    ry: 172.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 711.77,
    cy: 1449.25,
    rx: 299.43,
    ry: 167.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 711.77,
    cy: 1449.25,
    rx: 291.55,
    ry: 163.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 711.77,
    cy: 1449.25,
    rx: 283.67,
    ry: 158.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 711.77,
    cy: 1449.25,
    rx: 275.79,
    ry: 154.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 711.77,
    cy: 1449.25,
    rx: 267.9,
    ry: 150.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 711.77,
    cy: 1449.25,
    rx: 260.02,
    ry: 145.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 711.77,
    cy: 1449.25,
    rx: 252.14,
    ry: 141.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 711.77,
    cy: 1449.25,
    rx: 244.26,
    ry: 136.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 711.77,
    cy: 1449.25,
    rx: 236.38,
    ry: 132.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 711.77,
    cy: 1449.25,
    rx: 228.49,
    ry: 128.01
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 711.77,
    cy: 1449.25,
    rx: 220.61,
    ry: 123.59
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1354.27 921.31c.17-1.31.25-2.59.38-3.89.11-1.08.23-2.17.32-3.25.3-3.72.5-7.41.49-11 0-14.94-2.76-27.64-7.64-37.7L1233 798.57c4.89 10 7.6 22.75 7.64 37.69 0 3.63-.19 7.33-.49 11-.09 1.08-.21 2.16-.32 3.24-.24 2.38-.58 4.78-.94 7.18-.34 2.22-.72 4.45-1.16 6.69s-.93 4.62-1.48 6.93a859.8 859.8 0 0 0-1 4.27c-1 3.66-2 7.32-3.2 11l114.86 66.87c1-2.86 1.82-5.74 2.62-8.61.22-.79.37-1.57.58-2.35.37-1.43.71-2.85 1-4.28s.68-2.6 1-3.9c.21-1 .32-2 .52-3q.65-3.36 1.15-6.7c.09-1.1.35-2.21.49-3.29Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603 558.72c27.21 44.72 42.69 104.26 42.89 176.67.31 110.27-34.84 231.71-93.19 342.89l-38.7-23.51-167.18-101.38c5.59-17 8.68-34.16 8.64-50.33 0-14.94-2.76-27.64-7.64-37.69L1554.45 617Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-4)"
    },
    d: "M959.08 366.83 703.91 673.47l114.85 66.8 255.18-306.64-114.86-66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21437f"
    },
    d: "m756.86 1191.81-90.44-52.56-53.16-237.48 90.44 52.56 53.16 237.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1329.22 962.94 167.13 101.37c-51.8 101-126.12 192.5-210.44 252.86l-53.16-237.48c4.46-2.33 8.48-4.33 12.51-6.65 37.19-21.47 69.25-65.2 83.96-110.1Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.9 963.92c.11-.32.22-.65.32-1l-90.44-52.56c-.46 1.4-1 2.79-1.47 4.18-.57 1.63-1.14 3.26-1.75 4.89-.54 1.4-1.12 2.8-1.69 4.2s-1.1 2.75-1.69 4.12-1.31 2.93-2 4.4c-.57 1.25-1.12 2.5-1.71 3.74-.72 1.51-1.49 3-2.24 4.48-.6 1.18-1.18 2.37-1.8 3.54-.76 1.44-1.58 2.87-2.37 4.3-.67 1.2-1.32 2.42-2 3.61s-1.51 2.49-2.27 3.74-1.64 2.75-2.5 4.1c-.65 1-1.34 2-2 3-1.06 1.61-2.11 3.22-3.21 4.8-.62.89-1.27 1.76-1.91 2.65-1.29 1.79-2.59 3.57-3.92 5.31-.69.9-1.4 1.78-2.1 2.66q-2.37 3-4.83 5.88c-.66.78-1.32 1.56-2 2.33q-4.26 4.86-8.76 9.36c-.77.76-1.55 1.5-2.33 2.25q-2.19 2.12-4.42 4.13c-.91.82-1.82 1.61-2.74 2.41q-2.23 1.92-4.53 3.75c-.91.73-1.82 1.46-2.74 2.17a180.7 180.7 0 0 1-5 3.64c-.8.57-1.6 1.16-2.41 1.7-2.5 1.67-5 3.27-7.56 4.74-4 2.33-8 4.32-12.51 6.65l90.44 52.56c4.46-2.33 8.48-4.33 12.51-6.65 2.55-1.47 5.07-3.07 7.56-4.74.81-.54 1.61-1.14 2.41-1.7 1.68-1.18 3.36-2.38 5-3.64.92-.71 1.83-1.44 2.75-2.17q2.28-1.83 4.53-3.76l2.73-2.4c1.5-1.34 3-2.73 4.43-4.14.56-.54 1.14-1 1.7-1.58.21-.21.41-.45.62-.66q4.5-4.49 8.77-9.36c.23-.27.49-.5.72-.77.44-.51.84-1 1.28-1.55q2.46-2.89 4.83-5.9c.43-.54.88-1 1.31-1.59.26-.34.51-.7.77-1 1.34-1.75 2.64-3.52 3.93-5.32.49-.69 1-1.36 1.51-2.06.14-.19.27-.4.41-.6 1.1-1.58 2.15-3.19 3.21-4.8.58-.87 1.19-1.72 1.75-2.61.09-.13.16-.26.24-.4.88-1.37 1.7-2.76 2.55-4.16.67-1.1 1.37-2.19 2-3.31l.21-.37c.69-1.2 1.35-2.42 2-3.63s1.45-2.55 2.14-3.85c.08-.14.15-.29.23-.44.61-1.16 1.18-2.34 1.78-3.51.66-1.32 1.36-2.62 2-3.94.08-.19.16-.38.25-.56.59-1.23 1.14-2.48 1.7-3.72s1.18-2.51 1.73-3.77c.09-.22.17-.44.27-.65.59-1.37 1.13-2.75 1.68-4.12.48-1.19 1-2.37 1.46-3.56.08-.21.15-.43.23-.64.62-1.63 1.18-3.26 1.75-4.89.42-1.08.83-2.13 1.19-3.21Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bfcecc"
    },
    d: "M743.74 697.26 653.3 644.7l206.63-248.32 90.44 52.56-206.63 248.32z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m1122 1053.24 1.2-.51-90.44-52.56c-2.48 1.07-4.93 2-7.35 2.8l-1.49.45c-2 .63-4 1.2-5.94 1.65l-.85.21c-2 .44-3.93.75-5.85 1-1.12.15-2.22.23-3.31.32-1.25.11-2.49.2-3.71.23h-2.73c-1.28 0-2.55-.1-3.8-.22-.8-.08-1.6-.17-2.39-.29-1.3-.18-2.57-.43-3.83-.71-.68-.15-1.37-.29-2-.47a44.78 44.78 0 0 1-4.33-1.43c-.39-.14-.8-.25-1.18-.41a46.21 46.21 0 0 1-5.38-2.64l90.44 52.56.5.29a43.82 43.82 0 0 0 4.67 2.28l.21.08c.39.16.79.26 1.18.41 1.16.44 2.31.89 3.51 1.24.27.08.55.12.82.19.67.18 1.35.32 2 .47s1.55.4 2.36.54c.48.09 1 .11 1.47.18.79.11 1.59.2 2.39.27.59.06 1.15.17 1.74.21s1.38 0 2.06 0h4.07c.77 0 1.58-.17 2.37-.24 1.1-.09 2.19-.17 3.31-.32.4-.06.79-.06 1.2-.12 1.53-.24 3.08-.54 4.65-.89l.86-.21c.9-.21 1.8-.41 2.71-.66s2.15-.65 3.22-1l1.49-.45c2.06-.64 4.15-1.39 6.15-2.25Z",
    transform: "translate(-529.06 -125.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1162.84 747.84 90.45 52.56c8.19 4.76 14.85 12.17 19.51 22l-90.45-52.56c-4.65-9.84-11.35-17.24-19.51-22Z",
    transform: "translate(-529.06 -125.09)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1272.8 822.35-90.45-52.56c-4.65-9.78-11.31-17.19-19.51-21.95l90.45 52.56c8.19 4.76 14.85 12.17 19.51 22",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1223.93 517.74c3.41-1.53 6.82-3.06 10.21-4.44.83-.34 1.66-.66 2.5-1q6-2.41 12-4.54c.77-.27 1.54-.57 2.31-.84q6.6-2.28 13.08-4.21l2.9-.84c2.93-.84 5.82-1.58 8.72-2.31 2.4-.61 4.81-1.2 7.2-1.74s4.87-1 7.29-1.51 4.73-.9 7.07-1.29c2.65-.44 5.28-.82 7.9-1.16 1.74-.23 3.48-.47 5.2-.66 2.89-.31 5.75-.53 8.61-.73 1.48-.1 3-.25 4.46-.32 4.16-.2 8.27-.3 12.33-.26.65 0 1.27.06 1.91.07 3.45.07 6.87.22 10.25.47 1.21.08 2.41.21 3.62.32 2.79.26 5.56.57 8.3.95 1.24.17 2.49.35 3.72.54 3.17.51 6.29 1.09 9.38 1.76.6.13 1.22.23 1.81.37 3.66.83 7.25 1.8 10.79 2.86 1 .28 1.9.61 2.85.91a172.568 172.568 0 0 1 11.01 3.94q4.25 1.71 8.36 3.64c.58.27 1.18.52 1.76.8 3.53 1.71 7 3.53 10.37 5.5l-90.44-52.56-1.79-1c-2.81-1.58-5.68-3.06-8.58-4.47-.58-.28-1.18-.52-1.76-.8-2-.95-4.06-1.91-6.15-2.78-.72-.31-1.48-.56-2.21-.86-1.05-.42-2.11-.82-3.17-1.22-2.58-1-5.2-1.87-7.85-2.72-.94-.3-1.88-.63-2.84-.91l-1.26-.41c-3.13-.91-6.31-1.72-9.53-2.45-.59-.14-1.19-.23-1.78-.36-2.34-.51-4.68-1-7.07-1.43-.77-.13-1.57-.21-2.35-.34-1.23-.19-2.47-.36-3.71-.54-2.74-.38-5.51-.69-8.31-.95-1.2-.11-2.4-.24-3.61-.32-.61-.05-1.2-.13-1.81-.17-2.79-.17-5.61-.24-8.44-.3-.64 0-1.27-.06-1.91-.07q-5.57-.06-11.26.19c-.35 0-.72.06-1.07.07-1.48.07-3 .22-4.46.32-2.86.2-5.72.42-8.62.74-1.72.18-3.46.42-5.19.65s-3.39.38-5.11.65c-.92.14-1.87.36-2.8.51-2.34.39-4.7.83-7.06 1.29s-4.85 1-7.29 1.51-4.8 1.13-7.21 1.74c-1.48.38-2.94.67-4.43 1.07s-2.86.83-4.29 1.24l-2.88.84q-6.49 1.93-13.1 4.22c-.76.26-1.52.55-2.29.83q-6 2.12-12 4.54c-.82.34-1.64.65-2.47 1-.47.19-.94.36-1.42.56-2.93 1.22-5.9 2.58-8.85 3.9-1.65.74-3.29 1.41-4.94 2.18-5 2.33-10.07 4.79-15.16 7.42l90.44 52.56c5.09-2.63 10.13-5.09 15.15-7.42 1.64-.81 3.3-1.49 4.97-2.23Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f9fb7"
    },
    d: "m658.17 681.8-90.44-52.55 16.55-279.54 90.44 52.56-16.55 279.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.77 527.36C1324 465.17 1427.3 487.23 1479.43 574L1272.8 822.35c-14.25-29.94-47.24-37.58-85.57-15.46Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M807.55 1105.58c.21-4.21.46-8.43.78-12.67.16-2.16.34-4.33.53-6.49q.55-6.3 1.28-12.63c.23-2 .43-4 .69-6 .36-2.94.82-5.91 1.24-8.87.62-4.39 1.26-8.79 2-13.21.49-3 1-5.94 1.58-8.91.78-4.27 1.59-8.55 2.47-12.84q1.07-5.13 2.2-10.28c.64-2.86 1.28-5.72 2-8.58.89-3.75 1.84-7.51 2.8-11.26.73-2.83 1.45-5.66 2.22-8.48q1.85-6.8 3.86-13.58c.5-1.69 1-3.38 1.47-5.07q2.86-9.42 6-18.83c.35-1 .72-2.07 1.08-3.11q2.63-7.72 5.43-15.44c.7-1.92 1.42-3.83 2.14-5.74q2.61-7 5.38-13.94c.6-1.51 1.19-3 1.8-4.54q3.59-8.83 7.4-17.62c3.67-8.45 7.54-16.84 11.53-25.2 1.05-2.19 2.13-4.36 3.2-6.54q4.85-9.91 10-19.72c1.06-2 2.1-4.06 3.18-6.08q6.59-12.3 13.59-24.38c.88-1.51 1.79-3 2.68-4.49q6.19-10.51 12.72-20.83c1.28-2 2.55-4.05 3.84-6.05q8.08-12.55 16.59-24.78 5.52-7.89 11.19-15.63c.11-.15.21-.3.32-.44 4-5.44 8.09-10.79 12.22-16.09 1.94-2.5 3.94-5 5.91-7.42 2.5-3.12 5-6.25 7.52-9.32 2-2.47 4.12-4.89 6.19-7.32 2.45-2.89 4.89-5.78 7.37-8.61q7.56-8.64 15.33-17l.93-1q8.25-8.77 16.73-17.16 5.43-5.37 10.94-10.57c1-.93 1.94-1.89 2.92-2.81q7.18-6.69 14.49-13.1c1.31-1.15 2.64-2.25 4-3.38 3.59-3.09 7.19-6.15 10.83-9.13 1.8-1.48 3.62-2.91 5.43-4.36 3.22-2.57 6.44-5.1 9.69-7.58 1.95-1.49 3.9-3 5.85-4.4 3.22-2.39 6.45-4.72 9.7-7 1.93-1.37 3.86-2.74 5.81-4.07 3.5-2.41 7-4.73 10.56-7 1.67-1.09 3.34-2.22 5-3.28 5.21-3.3 10.46-6.5 15.73-9.55 5.81-3.35 11.62-6.5 17.32-9.5l-90.44-52.56c-5.7 3-11.51 6.15-17.32 9.5a451.51 451.51 0 0 0-15.73 9.55c-1.69 1.06-3.36 2.19-5 3.28-3.53 2.29-7 4.61-10.55 7-2 1.33-3.88 2.71-5.82 4.08q-4.86 3.43-9.68 7c-2 1.46-3.92 2.92-5.87 4.41q-4.86 3.72-9.67 7.58c-1.82 1.45-3.64 2.88-5.45 4.37-3.62 3-7.21 6-10.79 9.1-1.33 1.14-2.67 2.25-4 3.4q-7.31 6.4-14.47 13.1c-1 .93-2 1.91-3 2.85-3.2 3-6.39 6-9.54 9.14-.46.45-.9.93-1.35 1.39Q924 605.25 915.71 614c-.29.31-.58.65-.88 1q-7.8 8.34-15.38 17c-.48.55-1 1.07-1.47 1.63-2 2.28-3.91 4.63-5.87 6.94s-4.17 4.88-6.22 7.36c-2.53 3.06-5 6.18-7.49 9.29-2 2.48-4 4.93-5.94 7.44-.36.47-.74.92-1.1 1.39q-5.64 7.26-11.11 14.69l-.37.51q-5.25 7.13-10.35 14.39c-.27.39-.52.79-.79 1.18q-8.52 12.2-16.59 24.78c-.52.8-1.09 1.58-1.6 2.39-.77 1.2-1.48 2.45-2.24 3.66q-6.51 10.3-12.73 20.83c-.64 1.09-1.34 2.15-2 3.25-.24.41-.45.83-.69 1.24q-7 12.07-13.59 24.39c-.36.67-.76 1.32-1.11 2-.72 1.35-1.36 2.73-2.07 4.08q-5.14 9.79-10 19.72c-.67 1.37-1.41 2.71-2.07 4.09-.4.81-.74 1.64-1.13 2.46-4 8.35-7.86 16.74-11.53 25.19l-.37.81a641.45 641.45 0 0 0-7 16.81c-.61 1.51-1.2 3-1.8 4.54-1.07 2.69-2.17 5.37-3.2 8.07-.75 2-1.45 3.9-2.18 5.85s-1.44 3.85-2.14 5.78q-2.82 7.71-5.45 15.45c-.34 1-.72 2-1.06 3.07-.09.27-.19.53-.28.8q-3 9-5.72 18.06c-.51 1.66-1 3.33-1.46 5-1 3.45-2.06 6.91-3 10.36-.3 1.09-.56 2.19-.86 3.28-.76 2.82-1.48 5.63-2.2 8.45-1 3.76-1.92 7.52-2.82 11.28-.68 2.87-1.32 5.73-2 8.59-.45 2-1 4-1.38 6-.3 1.42-.53 2.83-.82 4.25-.88 4.28-1.69 8.56-2.47 12.83-.54 3-1.09 5.95-1.58 8.92-.73 4.42-1.37 8.82-2 13.22-.29 2.08-.67 4.17-.94 6.25-.11.87-.19 1.74-.3 2.61-.25 2-.46 4-.68 6-.48 4.23-.91 8.43-1.28 12.63q-.28 3.24-.53 6.48c-.32 4.25-.57 8.48-.78 12.71-.09 1.9-.21 3.8-.28 5.69-.22 6-.36 12.06-.34 18 .29 103.36 36.79 176.08 95.65 210.29l90.44 52.56c-58.86-34.21-95.36-106.93-95.65-210.29 0-6 .12-12 .34-18 .09-1.84.21-3.76.3-5.67Z",
    transform: "translate(-529.06 -125.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1133.83 563.14c5.81-3.35 11.62-6.5 17.32-9.5l-16.55 279.53c-51.33 29.64-92.8 101.47-92.63 160.45.15 54.28 35.54 78.78 81.26 59.11l52.63 238.16a468.16 468.16 0 0 1-39.89 25.86c-181.1 104.56-328.45 20.67-329-187.43s145.76-461.62 326.86-566.18Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-12)"
    },
    d: "M333.91 702.47 0 900.52V575.26L333.91 377.2v325.27z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M355.68 712.1 21.77 910.16V584.89l333.91-198.05V712.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-13)"
    },
    d: "m0 575.26 21.77 9.63 333.91-198.05-21.77-9.64L0 575.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-14)"
    },
    d: "M21.77 910.16 0 900.52V575.26l21.77 9.63v325.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-15)"
    },
    d: "M355.68 386.84 21.77 584.89v65.34l333.91-198.06v-65.33z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M21.77 584.89 0 575.26v65.33l21.77 9.64v-65.34z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M842.92 564.15v-.22a1.09 1.09 0 0 1 0-.18V563.46a.41.41 0 0 0 0-.11v-.23a.62.62 0 0 1 0-.13c0-.16 0-.29.06-.43a.13.13 0 0 1 0-.06v-.52a1.42 1.42 0 0 0 0-.2v-.43a1 1 0 0 0 0-.17 1.21 1.21 0 0 0 0-.18v-.06c0-.1 0-.18.07-.26v-.15c0-.16.09-.3.14-.44l.13-.39v-.2c0-.07.05-.13.07-.2l.06-.13.06-.15v-.12a2.14 2.14 0 0 0 .1-.22v-.13l.18-.39.06-.11a2.92 2.92 0 0 1 .14-.31l.13-.26c0-.06.07-.13.11-.2.11-.22.23-.43.35-.63v-.06l.09-.15.16-.26.14-.22.16-.25.06-.09v-.07c.15-.23.31-.45.46-.66l.34-.45.26-.33v-.06l.32-.37.09-.11.21-.23.14-.14.15-.17h.06l.16-.16.13-.13.08-.07.16-.15.12-.11.09-.08.17-.15.1-.09.12-.09.16-.14.09-.07.14-.11a.91.91 0 0 1 .16-.11h.06l.19-.14.13-.09.36-.23.32-.2h.08l.26-.15.1-.05.13-.07.1-.05.17-.08.12-.06.32-.14.33-.12H851.74l.16-.05H854.16a2.44 2.44 0 0 1 .39.06h.08l.23.06h.25l.22.09h.1a2.29 2.29 0 0 1 .31.16l1.16.67h.09l.31.16 2.14 1.24-.31-.16h-.1l-.22-.09-.18-.06h-.11l-.23-.06h-.08l-.38-.05h-.4.57-.89l-.23.05h-.14l-.25.08h-.12l-.37.14-.37.16-.12.06-.27.13-.13.07-.36.19-.4.25-.35-.29-.13.09-.25.18-.16.12-.23.18-.16.14-.22.18-.17.14-.21.19-.16.16-.21.2-.16.15-.21.22-.14.15-.24.27a.52.52 0 0 0-.1.11l-.34.39v.06l-.28.35-.34.45c-.16.22-.32.44-.47.67l-.11.15a2.13 2.13 0 0 1-.16.25l-.14.23-.15.25a2.39 2.39 0 0 0-.13.21c-.12.21-.24.42-.35.64a1.71 1.71 0 0 0-.13.23l-.12.24-.17.35-.06.12c-.07.15-.14.3-.2.45l-.06.12c-.05.12-.09.23-.14.34l-.06.16c0 .11-.09.22-.13.33a.78.78 0 0 0 0 .14c-.06.14-.11.29-.16.43l-.15.47v.16a3 3 0 0 0-.1.32v.18c0 .06-.05.2-.08.3s0 .12 0 .18-.05.21-.07.32v.16c0 .14-.05.27-.07.41a.13.13 0 0 0 0 .06c0 .15 0 .31-.07.46s0 .09 0 .13v2.86a1.85 1.85 0 0 0 0 .23v.39l.06.22c0 .06 0 .12.05.17l.09.26a.78.78 0 0 0 .05.14c0 .14.11.28.17.42s.1.2.16.3c.05.1.11.19.17.29v.05a1.43 1.43 0 0 0 .14.2.21.21 0 0 0 .06.08 1.15 1.15 0 0 0 .14.17v.07l.21.21.18.17h.07l.17.13a1.81 1.81 0 0 0 .27.18l-1.94-1.13h.06a.18.18 0 0 0 .07.05l.24.16-2.13-1.24-.25-.16-.07-.05-.17-.12-.22-.19-.2-.21-.06-.07-.14-.17-.06-.08-.14-.2v-.05a2.26 2.26 0 0 1-.16-.26 2.59 2.59 0 0 1-.14-.29c-.06-.14-.12-.27-.17-.42v-.11l-.09-.26a.2.2 0 0 1 0-.06v-.11l-.06-.22a.21.21 0 0 1 0-.06.5.5 0 0 1 0-.14 1.29 1.29 0 0 1 0-.19v-2.06Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M854.78 552.49c-4.52 2.61-8.18 9-8.16 14.14s3.69 7.3 8.21 4.69 8.18-9 8.17-14.14-3.7-7.3-8.22-4.69Z",
    transform: "translate(-529.06 -125.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M816 580.69v-.05a1.09 1.09 0 0 0 0-.17 1 1 0 0 0 0-.17v-.76c0-.14 0-.28.06-.42a.13.13 0 0 1 0-.06l.06-.35v-.23a1.18 1.18 0 0 0 0-.2v-.42c0-.06 0-.12.05-.17a1.21 1.21 0 0 1 0-.18.29.29 0 0 1 0-.09 2.17 2.17 0 0 1 .07-.24v-.15c0-.14.08-.28.13-.43 0-.12.08-.25.13-.37a.14.14 0 0 1 0-.06v-.14c0-.07 0-.14.08-.2a.5.5 0 0 1 0-.13l.06-.16v-.11l.09-.23.06-.12.18-.4.06-.12.14-.3v-.05l.12-.24c0-.07.07-.14.11-.2.11-.21.23-.42.35-.63a1.4 1.4 0 0 1 .1-.16l.15-.25c0-.08.1-.15.14-.23l.86-.5.05-.08v-.08l.47-.66c.11-.16.23-.31.35-.46.09-.11.18-.21.26-.32v-.06l.31-.37a.52.52 0 0 1 .1-.11c.07-.08.13-.16.2-.23l.15-.16s.1-.11.16-.16l.17-.17.13-.13.08-.07a1.29 1.29 0 0 1 .17-.16l.11-.11.1-.08.16-.14a.87.87 0 0 1 .11-.09.52.52 0 0 1 .11-.1l.17-.13a.27.27 0 0 1 .08-.07l.14-.11.16-.12.06-.05.19-.13.13-.1.36-.24.32-.19.08-.05.26-.14.1-.06.13-.06.11-.06.16-.08H824.81l.33-.14.33-.13h.14l.17-.06h2.73l.26.06h.26l.22.09h.1l.31.16 1.17.68h.06l.33.18 2.14 1.24-.31-.16h-.1a.85.85 0 0 0-.22-.09l-.18-.06h-.11l-.23-.06h-.12l-.38-.06h-1.81l-.23.06h-.14l-.25.08h-.12l-.37.13-.38.17h-.12l-.27.13-.13.07-.36.2-.4.24-.39.25-.13.1-.25.18-.16.12c-.07.06-.15.11-.22.18l-.17.13-.22.18-.16.15-.21.19-.17.15-.21.21-.15.15-.22.22-.14.15-.24.26-.1.11c-.11.13-.23.26-.34.4l-.05.06-.27.34-.35.45-.47.66-.1.16c-.06.08-.11.17-.16.25l-.15.22-.15.26-.13.21c-.12.21-.24.42-.35.63l-.12.23-.13.25-.17.35-.06.11c-.07.15-.14.31-.2.46a.61.61 0 0 0-.05.12l-.15.34-.06.16c0 .11-.09.21-.13.32a.88.88 0 0 1-.05.15l-.15.43c-.06.17-.11.33-.16.49s0 .1 0 .15l-.09.33c0 .06 0 .12-.05.18s0 .2-.08.3a1.16 1.16 0 0 1 0 .18c0 .1 0 .21-.07.31v.17c0 .13-.05.27-.07.4s0 0 0 .06-.05.31-.07.47 0 .09 0 .13v2.26a.88.88 0 0 0 0 .17v.25a1.1 1.1 0 0 0 0 .18V585.14a1.33 1.33 0 0 0 .05.19 1.89 1.89 0 0 0 0 .23.84.84 0 0 1 0 .17l.09.26v.14c0 .05.11.28.17.41a2.11 2.11 0 0 0 .16.3 2.61 2.61 0 0 0 .17.28v.06a2.43 2.43 0 0 0 .14.2l.06.08.14.17.05.06.21.22a1.54 1.54 0 0 0 .19.17l.07.06.16.13h.05l.27.17-1.94-1.12h.13l.24.16-2.13-1.25a2.07 2.07 0 0 1-.25-.15h-.07l-.16-.13-.07-.06-.19-.16-.21-.22v-.06a2.09 2.09 0 0 1-.14-.17l-.06-.08a1.43 1.43 0 0 1-.14-.2v-.06c-.06-.09-.11-.18-.16-.27-.06-.1-.1-.19-.15-.29-.06-.13-.12-.27-.17-.41v-.1l-.09-.26v-.17l-.06-.23a.29.29 0 0 0 0-.09.84.84 0 0 0 0-.1V582.6a1.1 1.1 0 0 1 0-.18v-.25a.88.88 0 0 1 0-.16v-.07a1.85 1.85 0 0 1 0-.23V580.76Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.86 569c-4.52 2.61-8.18 8.94-8.16 14.14s3.69 7.29 8.22 4.68 8.17-8.94 8.16-14.14-3.69-7.25-8.22-4.68Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.09 597.24a.86.86 0 0 1 0-.17v-.18a.57.57 0 0 0 0-.13v-.16a.41.41 0 0 1 0-.11 1.64 1.64 0 0 1 0-.22.62.62 0 0 0 0-.13.09.09 0 0 0 0-.05l.06-.41v-.06l.06-.34v-.23a1.42 1.42 0 0 1 0-.2.43.43 0 0 1 0-.11 1.16 1.16 0 0 0 0-.18.74.74 0 0 0 0-.14v-.17c0-.06 0-.12.05-.18a.31.31 0 0 1 0-.08c0-.08 0-.16.07-.24v-.15c0-.14.09-.28.13-.42 0-.13.08-.25.13-.38v-.06l.05-.14c0-.06 0-.13.08-.2l.05-.13.06-.15.05-.12a2.14 2.14 0 0 1 .1-.22l.05-.12c.06-.13.11-.26.18-.39l.06-.11.15-.3c0-.08.08-.17.13-.25l.1-.2c.11-.21.23-.42.35-.63v-.06l.1-.15.15-.26.15-.22a2.13 2.13 0 0 1 .16-.25.45.45 0 0 1 0-.08.35.35 0 0 0 .05-.08c.16-.22.31-.45.47-.66l.35-.45.27-.34.05-.06c.1-.13.21-.25.32-.37l.1-.11.2-.22.15-.16.16-.17h.06l.15-.16.14-.13h.05l.19-.18.11-.11.1-.08.17-.15.1-.09.11-.09.17-.14.08-.07.15-.1.15-.12h.06l.19-.14.14-.09.35-.23.32-.2h.08l.26-.15.1-.05.14-.07.1-.05.16-.08.12-.06.33-.14.33-.12h.12l.17-.06h2.21c.13 0 .26 0 .38.06h.05l.26.06h.11l.15.05.22.09h.11l.3.16 1.17.67h.09l.31.16 2.13 1.24c-.1 0-.2-.11-.3-.15l-.11-.05-.22-.09-.18-.06h-.11l-.23-.06h-.07l-.39-.06H802.45l-.22.06h-.15l-.25.07h-.12l-.37.14-.38.16-.12.06-.26.13-.14.07-.35.2a3.26 3.26 0 0 0-.4.24l-.38.26-.14.09-.25.19-.15.11-.23.18-.17.14.63-.4-.17.15-.21.18-.17.16-.21.2-.15.16-.21.22-.15.14-.24.27-.1.11-.33.39a.18.18 0 0 0 0 .07c-.1.11-.19.22-.28.34l-.35.45c-.16.21-.31.43-.46.66a.91.91 0 0 0-.11.16 2.13 2.13 0 0 0-.16.25l-.15.22-.15.26a2.39 2.39 0 0 1-.13.21c-.12.2-.24.41-.35.63l-.12.23c0 .08-.09.16-.13.25s-.11.23-.17.34l-.06.12-.2.45v.12l-.15.35-.06.15c0 .11-.08.22-.13.33a.78.78 0 0 1 0 .14l-.15.43q-.09.26-.15.48v.16l-.09.32v.18c0 .06 0 .2-.07.31s0 .12 0 .18l-.06.31v.16c0 .14 0 .27-.07.41s0 0 0 .06l-.06.46v.94a.76.76 0 0 0 0 .15v2.13a1.29 1.29 0 0 1 0 .19v.2l.06.22a.84.84 0 0 0 0 .17 2 2 0 0 0 .08.26s0 .1 0 .14.11.28.18.42l.15.3c.06.1.11.2.17.29.05.07.09.14.14.2l.06.08c0 .06.09.12.14.17l.06.07.2.21.19.17.07.06.17.12a.18.18 0 0 0 .07.05l.24.16-1.93-1.13a.18.18 0 0 1 .07.05l.25.15-2.14-1.24-.24-.16h-.05l-.19-.14-.07-.06a1.54 1.54 0 0 1-.19-.17c-.08-.07-.15-.15-.22-.22v-.06l-.14-.18-.06-.07-.14-.2v-.06a2.26 2.26 0 0 1-.16-.26l-.15-.29a4.08 4.08 0 0 1-.17-.42v-.1c0-.09-.06-.18-.08-.26v-.07a.43.43 0 0 1 0-.11 1.41 1.41 0 0 1-.06-.22v-.49a.5.5 0 0 0 0-.12 1.1 1.1 0 0 0 0-.18V597.6c-.48-.12-.48-.24-.47-.36Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.94 585.59c-4.52 2.61-8.17 8.94-8.16 14.13s3.7 7.3 8.22 4.69 8.18-8.95 8.16-14.14-3.69-7.27-8.22-4.68Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.57
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m79.86 807.23 224.75-130.09M79.86 781.08l224.75-130.09M79.86 754.93l224.75-130.09M79.86 728.78l224.75-130.09M79.86 702.63l224.75-130.09M79.86 676.48l224.75-130.09M79.86 650.33l224.75-130.09M98.64 812.97V623.52M119.23 800.56V611.11M139.82 788.14V598.69M160.42 775.72V586.27M181.01 763.31V573.86M201.6 750.89V561.44M222.2 738.47V549.02M242.79 726.06V536.61M263.38 713.64V524.19M283.97 701.22V511.77M304.57 688.81V499.36"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M632.4 916.73a20.25 20.25 0 0 1-3.37-.28c-17-2.87-28-26.4-28.45-27.4l3.47-1.6c.1.23 10.62 22.71 25.62 25.24 6.46 1.08 13-1.76 19.4-8.44 12.76-13.3 19.93-43.6 26.25-70.33 7.3-30.85 13.6-57.49 27.32-58.47 12.88-.93 17.5 13 21.59 25.23 2.78 8.34 5.66 17 10.59 18.93 2.21.89 4.89.47 8.18-1.26 8.56-4.53 12-21 15.59-38.38 6.12-29.45 13.71-66.11 51.55-60l2.48 1c-34.2-5.53-44.21 30.48-50.29 59.79-4 19.11-7.4 35.61-17.55 41-4.28 2.26-8.11 2.75-11.38 1.43-6.57-2.63-9.59-11.68-12.79-21.26-3.83-11.48-7.76-23.33-17.7-22.64C692 780 685.4 807.88 679 834.8c-6.76 28.54-13.74 58-27.22 72.09-6.24 6.54-12.78 9.84-19.38 9.84Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.89 917.69a20.17 20.17 0 0 1-3.37-.28c-17-2.87-28-26.4-28.45-27.4l3.47-1.59c.1.22 10.62 22.71 25.62 25.23 6.46 1.09 13-1.76 19.39-8.44 12.77-13.3 19.94-43.59 26.26-70.32 7.3-30.85 13.6-57.5 27.32-58.48 12.88-.92 17.5 13 21.59 25.24 2.78 8.33 5.66 17 10.59 18.93 2.21.88 4.89.47 8.18-1.27 8.56-4.52 12-21 15.59-38.37 6.11-29.45 13.71-66.12 51.54-60l-.61 3.77c-34.2-5.53-41.11 27.67-47.2 57-4 19.11-7.39 35.61-17.54 41-4.28 2.27-8.11 2.75-11.38 1.44-6.57-2.64-9.59-11.68-12.79-21.26-3.83-11.48-7.76-23.34-17.7-22.64-10.92.78-17.51 28.62-23.88 55.54-6.75 28.54-13.73 58-27.21 72.09-6.31 6.51-12.8 9.81-19.42 9.81Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-23)"
    },
    d: "m75 762.36 2.48.97-3.46 1.59-2.49-.96 3.47-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.15 861.08c-7.18 0-14.12-3.81-20.71-11.38-10.58-12.16-20.88-17.9-30.67-17-13 1.15-20.74 13.89-20.82 14l-2.73-1.63c.34-.58 8.62-14.24 23.24-15.56 10.85-1 22.08 5.11 33.38 18.1 7.48 8.6 15.31 11.82 23.28 9.58 22.19-6.22 42.83-53.07 50-94.78 4.58-26.74 12.59-58.65 24.77-58.81h.11c9.43 0 15.25 19.31 18.47 35.54 7 35.26 14.75 38 17 38.06 3.32 0 8-5.54 11.3-21.1.79-3.71 1.57-7.65 2.38-11.72 5-25.35 10.76-54.08 22.25-61.34a10.9 10.9 0 0 1 8.74-1.41l-.78 3.09a7.64 7.64 0 0 0-6.26 1c-10.34 6.53-16.16 35.77-20.83 59.27-.81 4.08-1.6 8-2.38 11.75-3.21 15.24-8.33 23.63-14.42 23.63-9.91-.06-16.37-22.12-20-40.62-6.07-30.54-13.26-33-15.37-33-5.85.08-14.62 14.88-21.68 56.17-7.21 42.1-28 90.51-52.25 97.32a21.82 21.82 0 0 1-6.02.84Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.44 862.6c-7.18 0-14.13-3.81-20.71-11.38-10.59-12.16-20.88-17.9-30.67-17-13 1.16-20.75 13.89-20.82 14l-2.74-1.62c.35-.58 8.63-14.25 23.25-15.56 10.84-1 22.08 5.11 33.38 18.1 7.47 8.59 15.31 11.81 23.28 9.58 22.19-6.22 42.83-53.08 50-94.79 4.58-26.74 12.59-58.65 24.76-58.81h.1c9.43 0 15.25 19.31 18.47 35.55 7 35.26 14.74 38 16.95 38.05 3.32 0 8-5.54 11.31-21.1.78-3.7 1.57-7.65 2.38-11.71 5-25.35 10.75-54.09 22.25-61.34a10.82 10.82 0 0 1 8.74-1.41l-.79 3.08a7.66 7.66 0 0 0-6.26 1c-10.32 6.54-16.17 35.76-20.85 59.29-.81 4.07-1.59 8-2.38 11.75-3.21 15.23-8.33 23.62-14.41 23.62-9.91-.06-16.37-22.12-20-40.62-6.06-30.53-13.25-33-15.37-33-5.85.08-14.61 14.87-21.68 56.17-7.2 42.09-28 90.5-52.24 97.31a21.48 21.48 0 0 1-5.95.84Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-26)"
    },
    d: "m1237.75 1244.71-473.1 285.69v-483.26l473.1-280.61v478.18z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m1268.6 1258.36-473.1 285.7V1060.8l473.1-280.61v478.17z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-27)"
    },
    d: "m764.65 1047.14 30.85 13.66 473.1-280.61-30.85-13.66-473.1 280.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-28)"
    },
    d: "m795.5 1544.06-30.85-13.66v-483.26l30.85 13.66v483.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-29)"
    },
    d: "M1268.6 780.19 795.5 1060.8v92.56l473.1-280.61v-92.56z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m795.5 1060.8-30.85-13.66v92.57l30.85 13.65v-92.56z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1738.41 979.26v-.1a1.48 1.48 0 0 1 0-.21 2 2 0 0 1 0-.25 1.36 1.36 0 0 1 0-.2V977.63a.15.15 0 0 1 0-.07c0-.19 0-.38.08-.58s0-.06 0-.09 0-.32.08-.49a.29.29 0 0 0 0-.08v-.24a2.8 2.8 0 0 1 .06-.28v-.16l.06-.25v-.2l.06-.23a2.5 2.5 0 0 1 .07-.26v-.08a3.72 3.72 0 0 1 .11-.38l.06-.22v-.06c.06-.2.12-.4.19-.6v-.05c.06-.17.12-.35.19-.53v-.08l.07-.2.11-.29.07-.18.09-.22.07-.16c0-.11.09-.21.13-.32l.08-.17v-.06c.09-.19.17-.38.26-.56 0-.06 0-.12.08-.17s.13-.28.2-.43v-.06l.18-.35.15-.28.51-.91.05-.07.13-.23c.08-.12.15-.24.22-.36l.2-.31c.08-.12.16-.24.23-.36a1 1 0 0 1 .08-.11l.07-.11.66-.94c.16-.21.32-.43.49-.64l.37-.46.07-.08c.14-.18.29-.35.44-.53l.13-.15.29-.33h.06l.2-.21.22-.23.08-.09.22-.21.19-.19.11-.1.23-.22.17-.15.13-.12.24-.2.1-.09.21-.17a2.11 2.11 0 0 1 .23-.19l.12-.1c.07-.06.14-.1.2-.16l.22-.16.09-.07.27-.19.19-.14.49-.33.45-.28.11-.06.37-.21.14-.07.19-.1.15-.07.23-.11.17-.08h.07l.46-.19.47-.18h.23l.24-.08h.07l.25-.07h2.88a4.86 4.86 0 0 1 .55.07h.11l.33.08.15.05.21.06c.13 0 .23.09.33.13l.15.06.43.23 1.65 1 .13.05.44.23 3 1.76c-.14-.08-.28-.16-.43-.23l-.15-.06c-.1 0-.2-.09-.3-.12l-.26-.09h-.11l-.38-.1h-.14c-.2 0-.38-.06-.57-.08h-2.06l-.29.05h-.21l-.32.08-.2.06-.36.11h-.17l-.52.2-.53.23-.17.08-.38.18-.18.1-.51.28-.57.34-.55.36-.18.14-.36.26-.22.16-.32.26a2.23 2.23 0 0 0-.24.19l-.31.26c-.08.07-.16.13-.24.21l-.29.26-.24.22-.29.29a2.28 2.28 0 0 0-.22.22c-.1.1-.21.2-.3.31l-.21.21c-.11.12-.22.25-.34.37a1.07 1.07 0 0 1-.14.16l-.48.56-.07.09-.39.48c-.17.21-.33.43-.49.64-.23.31-.45.62-.66.94l-.15.22c-.08.12-.16.24-.23.36l-.2.31c-.08.12-.15.24-.22.37l-.18.29c-.17.3-.34.6-.5.9-.06.11-.12.22-.17.33a3.9 3.9 0 0 0-.19.35l-.24.49-.08.16-.29.65c0 .05 0 .11-.07.17s-.14.32-.2.48l-.09.22-.18.47c0 .06 0 .13-.08.2l-.21.61a.2.2 0 0 0 0 .06c-.08.22-.15.44-.22.67l-.06.21-.13.46a2.5 2.5 0 0 1-.07.26c0 .14-.07.28-.1.43l-.06.25c0 .15-.07.3-.1.44s0 .16 0 .24-.08.38-.11.57V980q-.06.33-.09.66V981.98a1.48 1.48 0 0 1 0 .21V984.89l.06.32c0 .09 0 .18.05.28s0 .18.07.27a3 3 0 0 0 .08.32c0 .08 0 .16.07.24l.12.37a1.59 1.59 0 0 1 .07.2c.08.2.16.4.25.59s.14.29.22.42l.24.4.06.08.19.29.09.11.2.24.07.09.29.3a3 3 0 0 0 .26.24l.1.08.24.18.1.07a3.37 3.37 0 0 0 .35.22l-2.74-1.59.08.06.09.07.35.22-3-1.76-.34-.22h-.07l-.27-.21-.1-.08c-.09-.08-.18-.15-.27-.24-.11-.11-.21-.21-.3-.32l-.08-.09-.2-.25-.08-.11-.2-.28v-.08a4 4 0 0 1-.23-.39l-.21-.4c-.09-.19-.17-.39-.25-.59v-.05a.88.88 0 0 1 0-.15 2.29 2.29 0 0 1-.12-.37v-.24l-.09-.32v-.28l-.06-.27v-2.4c.15-.25.15-.43.16-.6Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1755.21 962.75c-6.41 3.7-11.59 12.67-11.57 20s5.24 10.34 11.64 6.64 11.59-12.67 11.57-20-5.23-10.34-11.64-6.64Z",
    transform: "translate(-529.06 -125.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1700.27 1002.7v-.75a1.79 1.79 0 0 1 0-.23.76.76 0 0 1 0-.15v-.32a1.1 1.1 0 0 0 0-.18v-.07c0-.2 0-.39.08-.59v-.08c0-.17 0-.33.08-.49a.29.29 0 0 0 0-.09l.05-.23.06-.29v-.16l.06-.25v-.2l.06-.23a2.5 2.5 0 0 1 .07-.26v-.12l.1-.34.06-.21c.07-.22.14-.42.2-.62v-.06c.06-.17.13-.35.19-.53v-.08l.07-.2c0-.09.08-.19.11-.28l.08-.19c0-.07.06-.14.08-.22v-.1a4 4 0 0 1 .16-.38l.07-.17v-.06c.08-.19.16-.38.25-.56l.08-.17.21-.42v-.07l.18-.35.15-.28c.16-.3.32-.6.5-.89v-.08l.14-.22.21-.36.21-.32.22-.36a.31.31 0 0 0 0-.07 1.49 1.49 0 0 1 .11-.15c.21-.32.43-.63.65-.94.16-.21.32-.43.49-.64.13-.16.26-.31.38-.47a.27.27 0 0 0 .07-.08c.14-.18.3-.35.45-.52l.14-.15c.09-.11.19-.22.29-.32v-.06l.2-.21.22-.23.09-.08a2.28 2.28 0 0 1 .22-.22l.18-.18.11-.1.24-.23.16-.15.13-.11.24-.21.15-.13.16-.13.23-.19.12-.1.21-.15.21-.17.09-.07.28-.19.18-.13.51-.33.45-.27.12-.07.36-.21a.61.61 0 0 0 .14-.07l.19-.1.15-.07.23-.11.17-.08.48-.21.47-.18.19-.06.24-.08h.11l.21-.06h2.88a4.85 4.85 0 0 1 .55.08h.13l.36.09h.16l.2.07.31.12.15.07.43.22 1.65 1 .13.06c.15.07.3.14.44.22l3 1.76c-.14-.08-.29-.15-.44-.22l-.15-.07-.3-.12-.26-.09h-.15l-.34-.08h-.16a5 5 0 0 0-.54-.08h-2.06l-.3.06h-.21l-.32.08-.2.06-.36.11h-.16l-.53.2-.54.23-.16.08-.38.18-.19.1-.51.28-.57.34c-.19.12-.38.24-.56.37l-.18.13-.36.26a1.84 1.84 0 0 0-.22.17 3.92 3.92 0 0 0-.32.25l-.24.19-.3.26-.24.21-.3.26-.24.23-.29.28c-.07.07-.15.14-.22.22l-.3.31-.2.21c-.12.12-.23.25-.35.38l-.14.15c-.16.19-.32.37-.47.56l-.08.09-.39.48-.49.65c-.23.31-.45.62-.66.94l-.15.22-.23.36c-.07.1-.13.21-.2.32s-.15.24-.22.36l-.18.3c-.17.29-.34.59-.5.89-.06.11-.12.22-.17.33l-.18.35c-.09.16-.16.33-.24.49a1.3 1.3 0 0 0-.08.17c-.1.21-.2.42-.29.64l-.08.17c-.07.16-.14.32-.2.48l-.09.22-.18.47-.08.2-.21.61v.06c-.08.22-.15.44-.21.67a1.72 1.72 0 0 0-.07.21c0 .16-.09.31-.13.46l-.06.26c0 .14-.08.29-.11.43l-.06.25c0 .15-.07.3-.1.45s0 .15 0 .23-.07.38-.11.58v.08c0 .22-.07.44-.09.66a1.1 1.1 0 0 0 0 .18v1.14a1.48 1.48 0 0 0 0 .21V1007.87a1.94 1.94 0 0 1 0 .24c0 .12 0 .24.05.35v.26l.06.31.06.28c0 .09 0 .18.06.28s.05.21.08.31l.07.25.12.36c0 .07.05.14.07.2s.16.4.25.59.14.29.22.43l.24.41.06.07a3 3 0 0 0 .2.29l.08.11.2.24.08.09c.09.11.19.21.29.31a3 3 0 0 0 .28.25l.1.09.23.17h.07l.38.25-2.74-1.6.08.06.1.07a2.46 2.46 0 0 0 .34.22l-3-1.75-.35-.22-.1-.08a1.88 1.88 0 0 1-.24-.18l-.1-.08-.26-.23-.29-.31-.07-.09-.2-.24-.06-.08c-.1-.12-.16-.22-.23-.32v-.07l-.22-.38c-.07-.14-.14-.27-.2-.41-.09-.19-.17-.39-.25-.59s0-.1-.05-.15l-.12-.36v-.1a.83.83 0 0 1 0-.15c0-.1-.06-.21-.08-.31a.93.93 0 0 1 0-.13v-.15a2.74 2.74 0 0 1 0-.28V1005.79a2.34 2.34 0 0 0 0-.26.38.38 0 0 0 0-.08v-.27a1.94 1.94 0 0 1 0-.24V1003.78c.24-.73.24-.9.25-1.08Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1717.11,
    cy: 999.52,
    rx: 16.36,
    ry: 9.47,
    transform: "rotate(-59.84 1343.813 1396.638)",
    style: {
      fill: "url(#linear-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.13 1026.14v-.06a2.45 2.45 0 0 0 0-.25 2 2 0 0 0 0-.25 1.23 1.23 0 0 0 0-.19v-.22a.76.76 0 0 1 0-.15v-.33a1.1 1.1 0 0 1 0-.18c0-.21 0-.41.09-.6s0-.05 0-.08l.09-.49a.22.22 0 0 1 0-.06v-.26l.06-.29v-.15l.06-.26v-.19l.06-.24a2.33 2.33 0 0 0 .07-.25v-.13c0-.11.07-.22.1-.33l.06-.22a.14.14 0 0 0 0-.06c.06-.2.13-.4.19-.6v-.05l.18-.53v-.09l.08-.2.1-.28.08-.18.09-.22.06-.16.14-.33.07-.17v-.06c.08-.19.17-.37.25-.56 0-.06 0-.11.07-.16l.21-.43a.25.25 0 0 1 0-.07l.17-.35.15-.28v-.05c.16-.3.33-.6.5-.89v-.08l.14-.22c.07-.12.14-.24.22-.36s.13-.21.2-.32.15-.24.23-.35l.07-.12.08-.11c.21-.31.43-.63.66-.94.16-.22.33-.43.49-.64l.38-.46.07-.09.45-.52.14-.15c.1-.11.19-.22.29-.32l.06-.06.19-.21a2.39 2.39 0 0 0 .22-.23l.09-.08.22-.22.18-.18.11-.1.24-.22.16-.16.14-.11.23-.21.15-.13.16-.13.23-.19.13-.1.2-.15.22-.17a.27.27 0 0 0 .08-.07l.28-.19.18-.13c.16-.12.33-.23.49-.33l.45-.28.12-.07c.12-.07.24-.14.37-.2l.14-.08.19-.09.09-.06.29-.13.16-.08h.07l.47-.2.46-.17h.07l.16-.06.24-.08h.12l.2-.06h2.88l.55.08h.16a2.62 2.62 0 0 1 .33.09h.16l.21.07.31.12.15.07.43.22 1.66 1 .13.06.43.22 3 1.76-.44-.22-.14-.06-.31-.13-.26-.08-.15-.05-.33-.09H1684.64l-.54-.08h-2.06l-.3.06h-.2l-.32.08h-.21l-.35.11-.17.06-.53.19-.53.23-.17.08-.38.19-.19.09-.51.28-.56.35-.55.37-.19.13-.36.26-.22.17-.32.25-.24.19-.3.26-.24.21-.3.27a2.39 2.39 0 0 0-.23.22l-.3.28-.22.22-.3.31-.2.21-.34.38a1.07 1.07 0 0 0-.14.16c-.17.18-.32.36-.48.55l-.05.06c-.16.19-.29.35-.41.52s-.33.42-.49.64c-.23.3-.44.62-.66.93l-.15.23c-.08.11-.15.23-.23.35l-.2.32-.22.36-.18.3c-.17.29-.34.59-.5.89l-.17.33-.18.35-.24.49a1.3 1.3 0 0 0-.08.17c-.1.21-.2.43-.29.64s0 .12-.08.17-.13.33-.2.49l-.09.22-.18.46c0 .07 0 .14-.07.2-.08.21-.15.41-.22.62-.08.24-.15.47-.22.69l-.06.22c0 .15-.09.3-.14.46l-.06.25c0 .15-.08.29-.11.43l-.06.26-.09.44a1.89 1.89 0 0 0 0 .23c0 .2-.07.39-.1.58v.08l-.09.66v1.32a1.48 1.48 0 0 0 0 .21V1032.36l.06.28.06.28.08.32a2.17 2.17 0 0 1 .07.24c0 .12.08.25.13.37a1.46 1.46 0 0 0 .07.19 6.07 6.07 0 0 0 .24.59c.07.15.15.29.22.43a4.23 4.23 0 0 0 .24.4v.08l.2.28a.76.76 0 0 0 .08.11c.07.08.13.17.2.24l.08.1.29.3.27.24.1.08.24.18.1.07.34.22-2.74-1.59.08.06.1.07.34.22-3-1.76c-.12-.07-.24-.14-.35-.22l-.1-.07-.24-.18-.09-.08-.27-.24-.28-.3-.08-.1a2.31 2.31 0 0 1-.2-.24l-.09-.11-.2-.28v-.08c-.08-.12-.16-.24-.23-.37-.08-.13-.14-.27-.21-.41-.09-.19-.17-.39-.25-.59 0-.07 0-.12-.06-.16l-.12-.37v-.1a.83.83 0 0 1 0-.15 2.81 2.81 0 0 1-.08-.31s0-.09 0-.13v-.15a2.33 2.33 0 0 1-.05-.28V1028.87a.5.5 0 0 1 0-.12v-1.67c.3-.59.3-.76.31-.94Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.93 1009.63c-6.41 3.7-11.59 12.67-11.56 20s5.23 10.33 11.64 6.63 11.58-12.67 11.56-20-5.23-10.33-11.64-6.63Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1739.54 1352.35-325.78 193.23a12.1 12.1 0 0 1-18.27-10.41v-240.09a25.32 25.32 0 0 1 12.4-21.78l324.35-192.38a12.23 12.23 0 0 1 18.47 10.52v241.29a22.82 22.82 0 0 1-11.17 19.62Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1752.57 1358.25-325.77 193.23a12.1 12.1 0 0 1-18.27-10.41V1301a25.32 25.32 0 0 1 12.4-21.78l324.35-192.38a12.23 12.23 0 0 1 18.47 10.52v241.29a22.81 22.81 0 0 1-11.18 19.6Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-36)"
    },
    d: "m1161 1066 45.48-27.34v-34.03l-45.48 27.34V1066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1422.28 1324.57 244.41-146.9a7 7 0 0 0 3.28-5.25c0-1.81-1.48-2.4-3.28-1.31L1422.28 1318a7.06 7.06 0 0 0-3.28 5.26c0 1.8 1.48 2.39 3.28 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1422.28 1338.3 244.41-146.89a7.06 7.06 0 0 0 3.28-5.26c0-1.81-1.48-2.39-3.28-1.31l-244.41 146.9a7 7 0 0 0-3.28 5.26c0 1.8 1.48 2.39 3.28 1.3Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1489.18 1311.83 177.51-106.69a7 7 0 0 0 3.28-5.26c0-1.8-1.48-2.39-3.28-1.31l-177.51 106.7a7 7 0 0 0-3.29 5.25c0 1.81 1.48 2.4 3.29 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-40)"
    },
    d: "m1161 1118.64 45.48-27.34v-34.03l-45.48 27.34v34.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1422.28 1377.21 244.41-146.9a7.06 7.06 0 0 0 3.28-5.26c0-1.8-1.48-2.39-3.28-1.31l-244.41 146.9a7.06 7.06 0 0 0-3.28 5.26c0 1.8 1.48 2.39 3.28 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.28 1390.94 1666.69 1244a7 7 0 0 0 3.28-5.25c0-1.81-1.48-2.4-3.28-1.31l-244.41 146.9a7 7 0 0 0-3.28 5.25c0 1.85 1.48 2.41 3.28 1.35Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1489.18 1364.47 177.51-106.69a7.06 7.06 0 0 0 3.28-5.26c0-1.8-1.48-2.39-3.28-1.31l-177.51 106.69a7 7 0 0 0-3.29 5.26c0 1.84 1.48 2.39 3.29 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-44)"
    },
    d: "m1161 1171.28 45.48-27.34v-34.03l-45.48 27.33v34.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1422.28 1429.84 1666.69 1283a7.06 7.06 0 0 0 3.28-5.26c0-1.8-1.48-2.39-3.28-1.31l-244.41 146.9a7 7 0 0 0-3.28 5.25c0 1.76 1.48 2.35 3.28 1.26Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1422.28 1443.58 244.41-146.9a7 7 0 0 0 3.28-5.25c0-1.81-1.48-2.4-3.28-1.31L1422.28 1437a7.06 7.06 0 0 0-3.28 5.26c0 1.81 1.48 2.4 3.28 1.32Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1489.18 1417.11 177.51-106.69a7.06 7.06 0 0 0 3.28-5.26c0-1.81-1.48-2.39-3.28-1.31l-177.51 106.69a7 7 0 0 0-3.29 5.26c0 1.8 1.48 2.39 3.29 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-48)"
    },
    d: "m1161 1223.92 45.48-27.34v-34.03l-45.48 27.33v34.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1422.28 1482.48 244.41-146.89a7.06 7.06 0 0 0 3.28-5.26c0-1.81-1.48-2.4-3.28-1.31l-244.41 146.9a7 7 0 0 0-3.28 5.25c0 1.83 1.48 2.4 3.28 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-49)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1422.28 1496.22 244.41-146.9a7.06 7.06 0 0 0 3.28-5.26c0-1.8-1.48-2.39-3.28-1.31l-244.41 146.9a7.06 7.06 0 0 0-3.28 5.26c0 1.8 1.48 2.39 3.28 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1489.18 1469.74 177.51-106.69a7 7 0 0 0 3.28-5.25c0-1.81-1.48-2.4-3.28-1.31l-177.51 106.69a7 7 0 0 0-3.29 5.25c0 1.81 1.48 2.4 3.29 1.31Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-52)"
    },
    d: "m206.07 1270.77 15.66 8.61v303.8l-15.66-8.61v-303.8z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m489 1522.67-173.46 98.39-93.81-37.88v-303.8L489 1127.77v394.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-53)"
    },
    d: "m489 1127.77-15.65-8.61-267.28 151.61 15.66 8.61L489 1127.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfd5df"
    },
    d: "M315.54 1621.06v-86.5l-93.81 48.62 93.81 37.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.55 1500 105.79-60.89c3.1-1.75 5.64-5.72 5.64-8.82 0-3.1-2.54-4.21-5.64-2.46l-105.79 60.89c-3.1 1.75-5.64 5.72-5.64 8.82 0 3.05 2.54 4.16 5.64 2.46Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-54)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.55 1463.24 105.79-60.88c3.1-1.75 5.64-5.72 5.64-8.83 0-3.1-2.54-4.2-5.64-2.45L782.55 1452c-3.1 1.75-5.64 5.72-5.64 8.82 0 3.07 2.54 4.18 5.64 2.42Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.55 1535.46 105.79-60.88c3.1-1.75 5.64-5.72 5.64-8.83 0-3.1-2.54-4.2-5.64-2.45l-105.79 60.89c-3.1 1.75-5.64 5.72-5.64 8.82 0 3.1 2.54 4.2 5.64 2.45Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.55 1571 188.09-106.27c3.1-1.75 5.64-5.72 5.64-8.82 0-3.1-2.54-4.21-5.64-2.45L782.55 1559.7c-3.1 1.76-5.64 5.73-5.64 8.83 0 3.1 2.54 4.2 5.64 2.47Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-57)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.55 1606.5 188.09-106.27c3.1-1.75 5.64-5.72 5.64-8.82 0-3.11-2.54-4.21-5.64-2.46l-188.09 106.27c-3.1 1.75-5.64 5.72-5.64 8.82 0 3.1 2.54 4.21 5.64 2.46Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.55 1642 188.09-106.26c3.1-1.76 5.64-5.73 5.64-8.83 0-3.1-2.54-4.2-5.64-2.45l-188.09 106.28c-3.1 1.75-5.64 5.72-5.64 8.82 0 3.1 2.54 4.21 5.64 2.44Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823.57 1654.12 147.07-82.86c3.1-1.75 5.64-5.72 5.64-8.82 0-3.1-2.54-4.21-5.64-2.45l-147.07 82.86c-3.1 1.75-5.63 5.72-5.63 8.82 0 3.1 2.53 4.2 5.63 2.45Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.23 1386.7v75.77l77.77-46.14v-75.76Zm19.18 41.53c0-9.27 4.88-20.29 11.81-28.14-2.67-.94-4.41-3.7-4.41-8 0-7.84 5.51-17.62 12.31-21.85s12.3-1.3 12.3 6.53c0 4.35-1.73 9.27-4.4 13.54 6.93-.78 11.8 4.18 11.8 13.44v13.94c0 .65 0 1.31-.08 2L928.5 1444c0-.61-.09-1.22-.09-1.87Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "#cdd4de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bcc5d3"
    },
    d: "m315.54 1534.56-3.4-2.14-90.41 46.8v3.96l93.81-48.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2253.46 2037.15s-.14 29-15 35.2-26.35 3.68-26.35 3.68l-52.13 23.8 124.87 87.56s4.61 32.73-28.11 28.48-34.21-26.36-34.21-26.36L2121 2130.44l-99.75 62s-8.51 31-40.81 34-35.28-29.63-35.28-29.63l119.44-93.67-65-21.81s-14.45 6.77-32.73-4-14.45-33.69-.85-37.94 164.06 45.05 164.06 45.05Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2179 2100.55 100.25 77.07a14.21 14.21 0 0 1-.72 23l-5.24 3.54a14.2 14.2 0 0 1-15.7.12l-129-84.09a14.17 14.17 0 0 0-15.46 0l-137.86 89.07a14.19 14.19 0 0 1-13.78.91l-8.76-4.14a14.2 14.2 0 0 1-2.27-24.34l102-74a14.21 14.21 0 0 0-4-25l-79.46-25.46a14.2 14.2 0 0 1-2.82-25.8 14.17 14.17 0 0 1 11.11-1.37l121.83 35.36a14.25 14.25 0 0 0 8.85-.3l121.65-44.61a14.22 14.22 0 0 1 11.2.61l4.78 2.38a14.2 14.2 0 0 1-.71 25.77l-62.8 27a14.2 14.2 0 0 0-3.09 24.28Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082.09 2060.48v.58c0 .19 0 .34.06.51l.09.59c0 .17.07.34.11.51s.09.38.14.57a4.91 4.91 0 0 0 .15.51l.18.56.19.51c.08.19.16.39.25.59s.15.32.23.49l.3.58c.09.16.17.32.26.47s.28.46.43.69l.27.42.55.75.25.33c.31.39.65.79 1 1.17l.29.3c.28.3.57.59.88.88l.43.39.55.49.54.45c.2.16.4.32.61.47l.58.44.65.46.63.42c.23.15.46.3.7.44s.59.38.9.56c.84.49 1.73.94 2.62 1.37l.72.34c.81.37 1.64.73 2.49 1.06l.33.14c.91.34 1.85.66 2.79 1 .66.2 1.33.38 2 .57l1.52.41c.71.17 1.43.31 2.15.46l1.57.32.66.1c.89.15 1.79.27 2.7.38l.78.1c1.05.11 2.1.2 3.16.26h.59c1.09 0 2.18.09 3.27.09h.33c.81 0 1.63 0 2.45-.07.65 0 1.31-.06 2-.11s1.2-.09 1.8-.15 1.29-.13 1.94-.21c.85-.11 1.71-.22 2.55-.36h.2c1.07-.19 2.13-.41 3.19-.65l.5-.11c1-.24 2-.5 2.93-.79l.82-.25c.8-.26 1.59-.52 2.36-.81l.68-.25c.7-.27 1.38-.57 2.06-.88l1-.43c1-.47 1.93-1 2.85-1.49 7.67-4.43 11.49-10.24 11.48-16l.12 21c0 5.8-3.82 11.61-11.48 16-.92.53-1.87 1-2.85 1.49l-1 .43c-.58.26-1.15.53-1.75.77l-.31.11-.68.25c-.77.28-1.56.55-2.36.81l-.82.25-.55.17c-.78.22-1.58.42-2.38.62l-.51.11-1.16.26c-.67.14-1.35.27-2 .38h-.2c-.54.09-1.09.18-1.64.25-.3.05-.61.07-.91.11-.65.08-1.29.15-1.94.21l-.93.11h-.87c-.66 0-1.32.08-2 .11l-1 .05h-3.99l-1.08-.05h-.58c-.89-.05-1.77-.12-2.65-.2l-.51-.07-.79-.09c-.9-.11-1.8-.23-2.69-.38l-.66-.11h-.32c-.42-.07-.83-.18-1.25-.26-.72-.15-1.44-.29-2.15-.46l-1.53-.41c-.67-.19-1.34-.37-2-.58-.14 0-.29-.07-.43-.12-.8-.26-1.59-.54-2.36-.83l-.33-.14c-.85-.33-1.68-.69-2.49-1.06l-.72-.34c-.89-.43-1.78-.89-2.62-1.38-.16-.09-.32-.18-.47-.28s-.29-.18-.43-.27-.48-.29-.7-.44l-.63-.42-.65-.46-.58-.44-.61-.47-.54-.45-.55-.49-.24-.2-.19-.2c-.31-.28-.6-.57-.88-.87l-.29-.3c-.35-.39-.69-.78-1-1.17a.1.1 0 0 0 0-.05l-.2-.28c-.19-.25-.38-.5-.55-.75l-.27-.42c-.15-.23-.29-.46-.43-.69 0-.06-.08-.12-.11-.19s-.1-.19-.15-.28l-.3-.58c-.08-.17-.16-.33-.23-.49s-.17-.4-.25-.59-.08-.18-.11-.27-.05-.16-.08-.24-.13-.37-.18-.56a4.91 4.91 0 0 1-.15-.51c0-.19-.1-.38-.14-.57s-.06-.2-.08-.31v-.21l-.09-.58c0-.17-.05-.34-.07-.51s0-.39 0-.59v-.68l-.12-21c-.1.15-.08.4-.07.63Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-63)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2093.54 2043.75c-15.23 8.8-15.32 23.06-.18 31.86s39.77 8.79 55 0 15.31-23.06.18-31.86-39.76-8.75-55 0Z",
    transform: "translate(-529.06 -125.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2100.54 1977.4v.31a2.06 2.06 0 0 0 0 .26 2.87 2.87 0 0 0 .05.31 2.56 2.56 0 0 0 0 .27c0 .1.05.2.08.3a2.76 2.76 0 0 0 .08.27l.09.3c0 .08.07.17.1.26l.13.31.12.26c0 .1.11.2.16.31l.14.24.22.36.15.22c.09.14.19.27.29.4l.12.17c.17.21.35.42.54.62l.15.16c.14.15.3.31.46.46l.22.21.3.25.28.24.32.25.3.23.35.24.33.22c.12.08.24.16.37.23l.47.29c.44.26.91.5 1.38.73l.37.18c.43.19.87.38 1.32.55l.17.08c.48.18 1 .34 1.47.5.34.11.7.2 1.05.3l.8.22 1.14.24.82.17h.35c.47.08.94.14 1.41.2h.42c.55.06 1.1.11 1.66.14H2122.21l1-.06 1-.08 1-.11 1.34-.19h.11c.56-.1 1.12-.21 1.67-.34l.27-.06c.52-.12 1-.26 1.54-.41l.43-.14c.42-.13.84-.27 1.24-.42l.36-.13c.37-.14.73-.3 1.09-.46l.52-.23q.78-.37 1.5-.78c4-2.33 6.05-5.39 6-8.44l.06 83.53c0 3.05-2 6.11-6 8.44q-.74.42-1.5.78l-.53.23c-.31.14-.61.28-.92.4l-.17.06-.35.13-1.25.43-.43.13-.28.09c-.42.12-.84.22-1.26.32l-.26.06-.62.14c-.35.08-.7.14-1.06.2h-.1l-.86.13c-.16 0-.33 0-.49.06l-1 .11-.48.06h-.46l-1 .06H2118.83c-.47 0-.93-.06-1.39-.11h-.27l-.41-.05c-.48 0-1-.12-1.42-.2l-.35-.05h-.16l-.66-.14c-.38-.08-.76-.15-1.13-.24l-.81-.22q-.52-.13-1.05-.3l-.23-.06-1.24-.44-.17-.07c-.45-.18-.89-.37-1.31-.56l-.38-.18q-.7-.34-1.38-.72l-.25-.15-.22-.14-.37-.24-.33-.22-.34-.24-.31-.23-.32-.25-.28-.24-.29-.25-.13-.11-.1-.1c-.16-.15-.31-.31-.46-.46l-.15-.16a7.57 7.57 0 0 1-.53-.62l-.11-.15-.29-.39-.14-.22c-.08-.12-.16-.24-.23-.37l-.06-.09a1 1 0 0 1-.07-.15c-.06-.1-.11-.21-.16-.31s-.08-.17-.12-.26a2.88 2.88 0 0 1-.13-.31l-.06-.14a.56.56 0 0 1 0-.12c0-.1-.07-.2-.1-.3a2.76 2.76 0 0 1-.08-.27c0-.1-.05-.2-.07-.3a.75.75 0 0 1 0-.16v-.11c0-.04 0-.2-.05-.3V2060.89a1.1 1.1 0 0 1 0-.18v-.18l-.06-83.53c-.13.16-.12.28-.12.4Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-64)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2106.56 1968.6c-8 4.63-8 12.13-.09 16.75s20.91 4.63 28.92 0 8.06-12.13.1-16.76-20.91-4.59-28.93.01Z",
    transform: "translate(-529.06 -125.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2075.33 1916.7v.69c0 .23.05.4.08.6s.07.45.11.68l.12.6c.05.23.11.45.17.67s.11.4.17.6.14.44.22.66.15.4.22.59.19.46.3.69.17.39.26.58l.36.69c.1.18.2.37.31.55s.32.54.5.81.2.33.32.49.42.59.64.88c.1.13.19.26.29.38.37.47.76.93 1.18 1.39l.34.34c.33.35.67.69 1 1l.5.47.65.57.64.52.71.56.68.51.77.54.73.5.83.52c.34.22.69.44 1.05.65 1 .57 2 1.1 3.08 1.61l.84.4c1 .44 1.93.86 2.93 1.25l.38.16c1.07.4 2.17.77 3.28 1.12.77.24 1.56.46 2.35.67.6.16 1.19.34 1.8.48.83.21 1.68.37 2.52.54.62.13 1.22.27 1.84.38l.78.12c1 .17 2.1.32 3.16.45l.92.11c1.23.13 2.47.24 3.71.31h.69c1.28.07 2.56.11 3.84.11h.38c1 0 1.92 0 2.88-.08.77 0 1.54-.07 2.31-.13l2.11-.17c.77-.08 1.53-.16 2.28-.26 1-.13 2-.25 3-.42h.23c1.26-.21 2.51-.47 3.74-.75l.59-.14c1.17-.28 2.32-.59 3.45-.92l1-.3c.94-.3 1.86-.61 2.77-1l.8-.29c.82-.32 1.62-.67 2.42-1 .39-.17.79-.33 1.18-.51 1.15-.55 2.27-1.13 3.34-1.75 9-5.19 13.5-12 13.48-18.83l.14 49.28c0 6.81-4.48 13.63-13.48 18.83-1.07.62-2.19 1.2-3.34 1.75-.39.18-.79.34-1.18.51-.68.3-1.35.62-2.06.89l-.37.14-.79.29c-.91.34-1.83.65-2.78 1l-.95.3-.65.2c-.92.26-1.85.49-2.79.72l-.6.13c-.45.11-.91.22-1.37.31q-1.17.24-2.37.45h-.23l-1.92.3-1.08.12c-.76.1-1.51.18-2.28.25-.36 0-.72.1-1.08.13h-1l-2.31.12c-.39 0-.77.06-1.16.07h-4.68l-1.26-.06h-.69c-1-.07-2.08-.14-3.11-.24l-.6-.07-.92-.11c-1.06-.13-2.12-.28-3.16-.45l-.78-.13h-.37c-.5-.09-1-.22-1.47-.32-.85-.17-1.69-.34-2.52-.54-.61-.15-1.2-.32-1.8-.48-.79-.22-1.58-.43-2.35-.67-.16 0-.34-.09-.5-.15-.95-.3-1.87-.63-2.78-1l-.38-.15c-1-.39-2-.81-2.93-1.25l-.84-.4c-1.05-.51-2.09-1-3.08-1.61l-.55-.33-.51-.32-.82-.52-.73-.5-.77-.54-.68-.51-.71-.56-.64-.52c-.22-.19-.44-.38-.65-.58s-.19-.15-.27-.23l-.23-.23c-.36-.34-.7-.68-1-1l-.34-.35c-.42-.45-.81-.91-1.18-1.38v-.06a3.81 3.81 0 0 1-.24-.32c-.22-.29-.44-.59-.65-.89s-.21-.32-.31-.48-.35-.54-.5-.81l-.14-.22-.17-.34-.36-.68c-.09-.19-.18-.39-.26-.58s-.2-.46-.3-.69l-.13-.31-.09-.28c-.08-.22-.15-.44-.22-.66s-.12-.4-.17-.6-.12-.45-.17-.67-.06-.24-.08-.36a2 2 0 0 1 0-.24c0-.23-.08-.46-.11-.69s-.06-.4-.08-.6 0-.46 0-.69v-.8l-.14-49.28c-.2.23-.18.5-.16.77Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-65)"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M2088.76 1897.07c-17.87 10.32-18 27.06-.21 37.39s46.69 10.32 64.56 0 18-27.07.22-37.4-46.68-10.32-64.57.01Z",
    transform: "translate(-529.06 -125.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1750.32 1784.13 2052.17 1640l93.79 96.61s-16.88 193.21-96.61 209.15-299.03-161.63-299.03-161.63Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740.62 1998.26s3 53.53 0 55.54-37.16 37.61-71.44 17.46-30.92-37.72-72.56-66.2-30.27-58.71 3.67-54.68 66.17 13.43 66.17 13.43Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-67)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.44 1723.82s27.51 91.13 16.71 161.29-7.1 103.62-7.1 103.62-5.85 21.59-46.87 15.11-46.41-36.7-46.41-36.7 1.08-150.94-17.27-243.32 1.08-171.17 86.35-175.49 14.59 175.49 14.59 175.49Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2196.27 1683.69s16.55 94.08-5.77 118.26-82.78 6.52-120 39.07-65.11 31.63-133 0-199.06-117.2-199.06-117.2-54-18.6-61.39-87.43 35.52-84.48 88.89-68.67 247.55 111.91 247.55 111.91Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-69)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1972.1 1042.28s-10 42.85-7.89 49.54a24.82 24.82 0 0 0 6.08 10.26s-11 11.17-9.22 23.84 6.63 53.34 17.7 60.16 29.37 8.17 34.44 10.73 17.37 71.94 17.37 71.94l108.42-42.63-28-143.12Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960.64 991.31c-9.92 5.5-2.82 52.09 12.83 60.88s33.92 17.78 33 30.79 7.36 21.25 5.71 36.38 1.21 19.16 3.8 19.63 5.82-28.72 19.66-31 12.15 20.52 6.72 29.92 1.28 18.08 21.92 16.34 55.61 2 65.83-15.26 30.43-55.5 24-75-23-23-23-23-1-56.75-67.47-47.52-86.54-11.29-103-2.16Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-71)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2049.91 1572.75s-140.82-158.14-224.81-137.14-224.81 170.94-224.81 170.94 16.64-5.5 42.43 13.34S1672 1668 1672 1668l159.08-104.53 146.16 131.08Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-72)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2155.4 1196.69s-8.56-18.2-26.76-17.13-107 42.81-112.36 65.28l-5.35 22.47s-95.23 35.31-100.58 64.21 42.8 109.15 43.87 156.23-18.22 164.79-18.22 164.79 25.68 82.4 130.55 83.47 133.76-58.85 133.76-58.85 23.54-247.19 46-316.75 31-166.93-10.7-169.07-80.21 5.35-80.21 5.35Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1913.88 1323.53c30.09-15.75 79.71 4.8 66.6 58.79s-64.8 180.5-85.62 185.13-64-50.91-54-87.17 52.71-146.11 73.02-156.75Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.86 1480.28 1675 1392.35s-23.14 1.54-30.09 28.54a72.73 72.73 0 0 0 4.63 48.6s188.44 130.85 245.3 98c.02-.04-51.66-15.49-53.98-87.21Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.72 1449.56s-26.7.7-44.19-39.18-51.07-66.46-59.46-73.45 16.79-9.1 43.37-9.1 45.47 20.29 54.57 35.68 26.14 32.67 26.14 32.67-25.22 23.3-20.43 53.38Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488 1606.23s10.69-20.4 40.66-15.28 57.38 19.72 71.87 16.56 22-2.76 42.49 8.28 26.15 53.76 26.15 53.76-23.45 35.44-32.88 36-148.29-99.32-148.29-99.32Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488 1606.23c12.65-18.07 97.78 30.19 118.13 44.63s46.09 48.24 25.67 57.92-78.83-35.61-106.4-44.14-55.77-32.16-37.4-58.41Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "#5c6691"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2470.94 1310.22-70.19 456.61a72.57 72.57 0 0 1-36.72 52.53l-288.74 159s72.58-491.91 102.89-520.22 292.76-147.92 292.76-147.92Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-78)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2434.76 1288.7 2166 1449.55a84.78 84.78 0 0 0-40.4 60.87l-55.23 391a34.33 34.33 0 0 1-50.24 25.44l-263.68-141.7a9.86 9.86 0 0 0-14.53 8.69v11.8a19 19 0 0 0 9.62 16.51l268 152c40.45 22.94 91.25-2.48 97.14-48.62l50.36-394.64a83.18 83.18 0 0 1 39.43-60.62l264.42-160.08Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-79)"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m1134.4 237.45-333 197.52V207.13l333-197.52v227.84z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-80)"
    },
    d: "m779.69 197.52 21.71 9.61 333-197.52L1112.69 0l-333 197.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linear-gradient-81)"
    },
    d: "m801.4 434.97-21.71-9.61V197.52l21.71 9.61v227.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.84 336.08c.07 21.64 8.39 36.26 21.61 41.89 11 4.69 25.49 3.08 41.3-6.05a108.91 108.91 0 0 0 25.77-21.3c21.76-23.88 36.79-57.77 36.72-87-.1-39.8-28.29-55.85-62.91-35.84-24.06 13.91-44.94 41.54-55.36 70.46-4.58 12.76-7.17 25.7-7.13 37.84Zm10.65-6.15a92.84 92.84 0 0 1 5.92-31.39c8.65-24 26-46.94 46-58.5 28.74-16.6 52.14-3.28 52.22 29.76.06 24.24-12.42 52.37-30.48 72.2a90.49 90.49 0 0 1-21.4 17.68c-13.12 7.58-25.11 8.92-34.29 5-11.01-4.68-17.92-16.78-17.97-34.75Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-82)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1361.77 375.6 114.5-68.45c2.31-1.38 4.19-4.4 4.19-6.71 0-2.3-1.88-3.06-4.19-1.67l-114.5 68.45c-2.31 1.38-4.2 4.4-4.2 6.71 0 2.31 1.89 3.07 4.2 1.67Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-83)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1361.77 393.14 114.5-68.45c2.31-1.38 4.19-4.4 4.19-6.71 0-2.3-1.88-3.06-4.19-1.67l-114.5 68.45c-2.31 1.38-4.2 4.4-4.2 6.71 0 2.3 1.89 3.06 4.2 1.67Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-84)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1402.08 386.4 74.19-44.17c2.31-1.38 4.19-4.4 4.19-6.71 0-2.31-1.88-3.06-4.19-1.67L1402.08 378c-2.31 1.39-4.19 4.41-4.19 6.71 0 2.29 1.88 3.07 4.19 1.69Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-85)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1361.77 453 114.5-68.45c2.31-1.38 4.19-4.41 4.19-6.71 0-2.31-1.88-3.06-4.19-1.67l-114.5 68.45c-2.31 1.38-4.2 4.4-4.2 6.71 0 2.34 1.89 3.1 4.2 1.67Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-86)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1361.77 470.58 114.5-68.45c2.31-1.39 4.19-4.41 4.19-6.71 0-2.31-1.88-3.06-4.19-1.67l-114.5 68.44c-2.31 1.39-4.2 4.41-4.2 6.72 0 2.3 1.89 3.09 4.2 1.67Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1402.08 463.83 74.19-44.16c2.31-1.39 4.19-4.41 4.19-6.71 0-2.31-1.88-3.06-4.19-1.68l-74.19 44.17c-2.31 1.38-4.19 4.4-4.19 6.71 0 2.31 1.88 3.06 4.19 1.67Z",
    transform: "translate(-529.06 -125.09)",
    style: {
      fill: "url(#linear-gradient-88)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingImg);
export default __webpack_public_path__ + "static/media/marketing-img.6d9522a822feda896395710e8358f895.svg";
export { ForwardRef as ReactComponent };